/* projects/common-module/src/lib/app-components/snack-bar/snack-bar.component.scss */
.theme-DEFAULT {
  --color-primary: #386dac;
  --color-accent: #FF4081;
  --color-minor: #c5cae9;
  --color-text: #212121;
  --color-secondary: #757575;
  --color-divider: #BDBDBD;
  --color-highlight-light-grey: #d3d3d3;
  --color-light-opacity: rgba(230, 230, 230, 0.85);
  --color-almost-white: #f0f0f0;
  --color-white: #ffffff;
  --color-green: forestgreen;
  --color-red: red;
  --color-yellow: #ffcc33;
  --color-orange: #ffa500;
  --color-map-basic: #2b8cf7;
}
.theme-BLUE {
  --color-primary: #002395;
  --color-accent: #F8D030;
  --color-minor: #CFD8DC;
  --color-text: #212121;
  --color-secondary: #757575;
  --color-divider: #BDBDBD;
  --color-highlight-light-grey: #d3d3d3;
  --color-light-opacity: rgba(230, 230, 230, 0.85);
  --color-almost-white: #f0f0f0;
  --color-white: #ffffff;
  --color-green: forestgreen;
  --color-red: red;
  --color-yellow: #ffcc33;
  --color-orange: #ffa500;
  --color-map-basic: #2b8cf7;
}
.theme-RED {
  --color-primary: #b63134;
  --color-accent: #FF9800;
  --color-minor: #e5c0c1;
  --color-text: #212121;
  --color-secondary: #757575;
  --color-divider: #BDBDBD;
  --color-highlight-light-grey: #d3d3d3;
  --color-light-opacity: rgba(230, 230, 230, 0.85);
  --color-almost-white: #f0f0f0;
  --color-white: #ffffff;
  --color-green: forestgreen;
  --color-red: red;
  --color-yellow: #ffcc33;
  --color-orange: #ffa500;
  --color-map-basic: #2b8cf7;
}
.theme-RED2 {
  --color-primary: #666465;
  --color-accent: #E30611;
  --color-minor: #e5c0c1;
  --color-text: #212121;
  --color-secondary: #757575;
  --color-divider: #BDBDBD;
  --color-highlight-light-grey: #d3d3d3;
  --color-light-opacity: rgba(230, 230, 230, 0.85);
  --color-almost-white: #f0f0f0;
  --color-white: #ffffff;
  --color-green: forestgreen;
  --color-red: red;
  --color-yellow: #ffcc33;
  --color-orange: #ffa500;
  --color-map-basic: #2b8cf7;
}
.theme-PURPLE {
  --color-primary: #7B1FA2;
  --color-accent: #E040FB;
  --color-minor: #E1BEE7;
  --color-text: #212121;
  --color-secondary: #757575;
  --color-divider: #BDBDBD;
  --color-highlight-light-grey: #d3d3d3;
  --color-light-opacity: rgba(230, 230, 230, 0.85);
  --color-almost-white: #f0f0f0;
  --color-white: #ffffff;
  --color-green: forestgreen;
  --color-red: red;
  --color-yellow: #ffcc33;
  --color-orange: #ffa500;
  --color-map-basic: #2b8cf7;
}
.theme-GREEN {
  --color-primary: #00796B;
  --color-accent: #03A9F4;
  --color-minor: #B2DFDB;
  --color-text: #212121;
  --color-secondary: #757575;
  --color-divider: #BDBDBD;
  --color-highlight-light-grey: #d3d3d3;
  --color-light-opacity: rgba(230, 230, 230, 0.85);
  --color-almost-white: #f0f0f0;
  --color-white: #ffffff;
  --color-green: forestgreen;
  --color-red: red;
  --color-yellow: #ffcc33;
  --color-orange: #ffa500;
  --color-map-basic: #2b8cf7;
}
.theme-GRAY {
  --color-primary: #455A64;
  --color-accent: #ff5252;
  --color-minor: #CFD8DC;
  --color-text: #212121;
  --color-secondary: #757575;
  --color-divider: #BDBDBD;
  --color-highlight-light-grey: #d3d3d3;
  --color-light-opacity: rgba(230, 230, 230, 0.85);
  --color-almost-white: #f0f0f0;
  --color-white: #ffffff;
  --color-green: forestgreen;
  --color-red: red;
  --color-yellow: #ffcc33;
  --color-orange: #ffa500;
  --color-map-basic: #2b8cf7;
}
.theme-BLACK {
  --color-primary: #000000;
  --color-accent: #da291c;
  --color-minor: #dda4a0;
  --color-text: #212121;
  --color-secondary: #757575;
  --color-divider: #BDBDBD;
  --color-highlight-light-grey: #d3d3d3;
  --color-light-opacity: rgba(230, 230, 230, 0.85);
  --color-almost-white: #f0f0f0;
  --color-white: #ffffff;
  --color-green: forestgreen;
  --color-red: red;
  --color-yellow: #ffcc33;
  --color-orange: #ffa500;
  --color-map-basic: #2b8cf7;
}
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family:
    "Helvetica Neue",
    Helvetica,
    sans-serif;
  font-size: 1.4rem;
}
.container .accent {
  color: var(--color-accent);
}
.container .accent.button {
  cursor: pointer;
}
/*# sourceMappingURL=snack-bar.component.css.map */
